import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import * as fromSupervisorSkill from './supervisor-skill.reducer'
import { EffectsModule } from '@ngrx/effects'
import { TagModule } from '../../tag/tag.module'
import { SupervisorSkillEffects } from './supervisor-skill.effects'
import { SupervisorSkillService } from './supervisor-skill.service'
import { SupervisorSkillSerializer } from './supervisor-skill.serializer'

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        TagModule,
        StoreModule.forFeature(fromSupervisorSkill.FEATURE_NAME, fromSupervisorSkill.supervisorSkillReducer),
        EffectsModule.forFeature([SupervisorSkillEffects])
    ],
    declarations: [],
    exports: [],
    providers: [
        SupervisorSkillService,
        {
            provide: SupervisorSkillSerializer,
            useClass: SupervisorSkillSerializer
        }
    ]
})
export class SupervisorSkillModule {}
